import { Redirect } from 'react-router';
import AppLayout from '../layout/app/AppLayout';
import PublicLayout from '../layout/public/PublicLayout';

const routes = [
  {
    path: '/public',
    component: () => <Redirect to='/' />, // Compatibility redirect
  },
  {
    path: '/app/allServices',
    component: () => <Redirect to='/todos-los-tramites' />, // Compatibility redirect
  },

  {
    path: '/app',
    component: AppLayout,
  },
  {
    path: '/tramite',
    component: AppLayout,
  },
  {
    path: '/todos-los-tramites',
    component: AppLayout,
  },
  {
    path: '/solicitar-tramite',
    component: AppLayout,
  },
  {
    path: '/contacto',
    component: AppLayout,
  },
  {
    path: '/consultas-generales',
    component: AppLayout,
  },
  {
    path: '/politicas-de-privacidad',
    component: AppLayout,
  },
  {
    path: '/preguntas-frecuentes',
    component: AppLayout,
  },
  {
    path: '/registro',
    component: AppLayout,
  },
  {
    path: '/base-legal',
    component: AppLayout,
  },
  // The catch-all route at the bottom is no longer needed because the sub-routers 
  // will handle it using the wildcard path '*' which will be updated in AppRoutes.js
  {
    path: '/',
    component: PublicLayout,
  },
];

export default routes;